"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaLang = exports.Size = exports.Theme = exports.CaptchaType = void 0;
var CaptchaType;
(function (CaptchaType) {
    CaptchaType["image"] = "image";
    CaptchaType["audio"] = "audio";
})(CaptchaType = exports.CaptchaType || (exports.CaptchaType = {}));
var Theme;
(function (Theme) {
    Theme["light"] = "light";
    Theme["dark"] = "dark";
})(Theme = exports.Theme || (exports.Theme = {}));
var Size;
(function (Size) {
    Size["normal"] = "normal";
    Size["compact"] = "compact";
})(Size = exports.Size || (exports.Size = {}));
// to ensure that the passed lang is supported we expose the supported langs
// all of these languages are taken from
// this list: https://developers.google.com/recaptcha/docs/language
var CaptchaLang;
(function (CaptchaLang) {
    CaptchaLang["Arabic"] = "ar";
    CaptchaLang["Afrikaans"] = "af";
    CaptchaLang["Amharic"] = "am";
    CaptchaLang["Armenian"] = "hy";
    CaptchaLang["Azerbaijani"] = "az";
    CaptchaLang["Basque"] = "eu";
    CaptchaLang["Bengali"] = "bn";
    CaptchaLang["Bulgarian"] = "bg";
    CaptchaLang["Catalan"] = "ca";
    CaptchaLang["ChineseHongKong"] = "zh-HK";
    CaptchaLang["ChineseSimplified"] = "zh-CN";
    CaptchaLang["ChineseTraditional"] = "zh-TW";
    CaptchaLang["Croatian"] = "hr";
    CaptchaLang["Czech"] = "cs";
    CaptchaLang["Danish"] = "da";
    CaptchaLang["Dutch"] = "nl";
    CaptchaLang["EnglishUK"] = "en-GB";
    CaptchaLang["EnglishUS"] = "en";
    CaptchaLang["Estonian"] = "et";
    CaptchaLang["Filipino"] = "fil";
    CaptchaLang["Finnish"] = "fr";
    CaptchaLang["FrenchCanadian"] = "fr-CA";
    CaptchaLang["Galician"] = "gl";
    CaptchaLang["Georgian"] = "ka";
    CaptchaLang["German"] = "de";
    CaptchaLang["GermanAustria"] = "de-AT";
    CaptchaLang["GermanSwitzerland"] = "de-CH";
    CaptchaLang["Greek"] = "el";
    CaptchaLang["Gujarati"] = "gu";
    CaptchaLang["Hebrew"] = "iw";
    CaptchaLang["Hindi"] = "hi";
    CaptchaLang["Hungarain"] = "hu";
    CaptchaLang["Icelandic"] = "is";
    CaptchaLang["Indonesian"] = "id";
    CaptchaLang["Italian"] = "it";
    CaptchaLang["Japanese"] = "ja";
    CaptchaLang["Kannada"] = "kn";
    CaptchaLang["Korean"] = "ko";
    CaptchaLang["Laothian"] = "lo";
    CaptchaLang["Latvian"] = "lv";
    CaptchaLang["Lithuanian"] = "lt";
    CaptchaLang["Malay"] = "ms";
    CaptchaLang["Malayalam"] = "ml";
    CaptchaLang["Marathi"] = "mr";
    CaptchaLang["Mongolian"] = "mn";
    CaptchaLang["Norwegian"] = "no";
    CaptchaLang["Persian"] = "fa";
    CaptchaLang["Polish"] = "pl";
    CaptchaLang["Portuguese"] = "pt";
    CaptchaLang["PortugueseBrazil"] = "pt-BR";
    CaptchaLang["PortuguesePortugal"] = "pt-PT";
    CaptchaLang["Romanian"] = "ro";
    CaptchaLang["Russian"] = "ru";
    CaptchaLang["Serbian"] = "sr";
    CaptchaLang["Sinhalese"] = "si";
    CaptchaLang["Slovak"] = "sk";
    CaptchaLang["Slovenian"] = "sl";
    CaptchaLang["Spanish"] = "es";
    CaptchaLang["SpanishLatinAmerica"] = "es-419";
    CaptchaLang["Swahili"] = "sw";
    CaptchaLang["Swedish"] = "sv";
    CaptchaLang["Tamil"] = "ta";
    CaptchaLang["Telugu"] = "te";
    CaptchaLang["Thai"] = "th";
    CaptchaLang["Turkish"] = "tr";
    CaptchaLang["Ukrainian"] = "uk";
    CaptchaLang["Urdu"] = "ur";
    CaptchaLang["Vietnamese"] = "vi";
    CaptchaLang["Zulu"] = "zu";
})(CaptchaLang = exports.CaptchaLang || (exports.CaptchaLang = {}));
//# sourceMappingURL=types.js.map